import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-choose-project',
  templateUrl: './choose-project.component.html',
  styleUrls: ['./choose-project.component.scss']
})
export class ChooseProjectComponent implements OnInit {

  tree: any[];

  project: any;
  school: any;

  headline: string = "Choose Project";
  registered: boolean = false;
  isMember: boolean = false;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

  isDisable() {
    if ( this.registered ) {
      return (this.isMember && (!this.project || !this.school)) || !((this.project ? this.project.properties.freeToRegister : false) || (this.school ? this.school.properties.freeToRegister : false));
    }
    else {
      if ( this.project ) {
        if ( this.project.properties.isMember ) {
          return false;
        }
        else if ( this.school && this.school.properties.isMember ) {
          return false;
        }
      } 
      return true;
    }
  }

  onChange() {
    if (this.school) this.school = null;
  }

  choose() {
    const result = this.school || this.project;
    this.activeModal.close(result);
    localStorage.setItem('project_id', JSON.stringify(result));
  }
}
